import React, { useState } from "react";
import { GridLegacy } from "@mui/material";
import FormTextTC from "../../components/Forms/FormTextTC";
import FormV2 from "../JamezzForm/FormV2";
import MainNavbar from "../../components/Navbars/MainNavbar";
import { withStyles } from "tss-react/mui";
import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import AuthProvider from "../../auth/AuthProvider";
import ImageUuids from "../Producten/ImageUuids";
import FormSwitchTC from "../../components/Forms/FormSwitchTC";

const endPoint = "core/articleTraitValues";

function ArticleTraitValueForm(props) {
  const [articleTraitValue, setArticleTraitValue] = useState(null);

  return (
    <AuthProvider prefix={"articleTraitValues"}>
      <MainNavbar paginaTitel={"Article Trait Values"} subject={articleTraitValue?.value} />
      <GridLegacy container spacing={1}>
        <GridLegacy item xs={12}>
          <FormV2
            endPoint={endPoint}
            mode={"onSubmit"}
            onGetModel={(profile) => {
              setArticleTraitValue(profile);
            }}
            parseInput={{
              img_uuids: (response) => {
                return response
                  ? JSON.parse(response).map((uuid) => ({
                      uuid: uuid,
                    }))
                  : [];
              },
            }}
            revalidateMode={"onChange"}
          >
            <GridLegacy container spacing={1}>
              <FormTextTC disabled={true} name={"value"} tDefault={"Name"} tKey={"articleTraitValues.name"} />
              <FormTextTC name={"sort_key"} tDefault={"Sort key"} tKey={"articleTraitValues.sortKey"} />
              <FormSwitchTC
                name={"is_active_in_jamezz"}
                tDefault={"Enabled"}
                tKey={"articleTraitValues.is_active_in_jamezz"}
              />
            </GridLegacy>

            {articleTraitValue ? <ImageUuids /> : null}
          </FormV2>
        </GridLegacy>
      </GridLegacy>
    </AuthProvider>
  );
}

export default withStyles(ArticleTraitValueForm, vestigingStyle);
